import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FwPlugins, { IFrame } from 'framework-plugins';
import { Helmet } from 'react-helmet';
import useSignalR from '../../helpers/useSignalR';

const PrestazioniAgevolate = ({ ufficio }) => {
  const refreshPrestazioneAgevolata = useCallback((evt) => {
    FwPlugins.postMessageToChilds('REFRESH_PRESTAZIONI_AGEVOLATE', null);
  }, []);

  const onDichiarazioneStatoModificato = useCallback((evt) => {
    FwPlugins.postMessageToChilds('REFRESH_PRESTAZIONI_AGEVOLATE', null);
  }, []);

  useSignalR('DichiarazioneStatoModificato', onDichiarazioneStatoModificato);
  useSignalR('DichiarazioneDatiAggiuntiviModificati', refreshPrestazioneAgevolata);

  return (
    <React.Fragment>
      <Helmet title="Prestazioni Agevolate" />
      <IFrame
        src={window.config.urlPrestazioniAgevolate}
        srcParams={{ ufficio }}
      />
    </React.Fragment>
  );
};

const mapStoreToProps = (store) => ({
  ufficio: store.utente.ufficioSelezionato.CodiceUfficio,
});

PrestazioniAgevolate.propTypes = {
  ufficio: PropTypes.string.isRequired,
};

export default connect(mapStoreToProps)(PrestazioniAgevolate);
